function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M437.563-202.497c-390.646,0,423.357,0-595.393,0v645.44c0.015,0.76,2.302,65.374,65.562,65.374H79.91  c2.242,0.062,57.653,5.194,57.653,59.186h9.224c0-53.991,55.416-59.124,57.774-59.188l172.059,0.002  c63.246,0,65.533-64.614,65.551-65.268v-645.547H437.563L437.563-202.497z",
  fill: "#000000"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#F5F5F5",
  points: "437.563,332.003 -9.265,332.003 -34.829,282.003 -60.752,332.003 -153.222,332.003   -153.222,385.991 -8.912,385.991 16.171,435.991 41.939,385.991 437.563,385.991 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M142.171,385.991h295.392v56.955c0,0-1.466,60.777-60.946,60.777c-59.492,0-172.181,0-172.181,0  s-62.265,1.517-62.265,60.78c0-59.264-62.262-60.78-62.262-60.78s-112.687,0-172.177,0c-59.491,0-60.955-60.777-60.955-60.777  v-56.955h92.47l26.324-50l51.032,100l25.336-50H142.171L142.171,385.991z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#adadad",
  points: "437.563,332.003 41.939,332.003 16.309,382.003 -34.839,282.003 -60.752,332.003 -153.222,332.003   -153.222,-197.899 437.563,-197.899 "
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: -133.614,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: -106.229,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: -79.843,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 51.193,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.995,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 77.594,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 156.797,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 130.396,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 209.599,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 183.197,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 262.401,
  cy: 369.353,
  r: 8.103,
  fill: "#000000"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 236,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 315.202,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.802,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 368.004,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.604,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 420.807,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 394.405,
  cy: 369.353,
  r: 8.104,
  fill: "#000000"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#fafafa",
  points: "-83.387,-107.62 -89.416,-42.289 -127.279,-31.36 -89.416,-20.669 -83.387,43.959 -77.567,-20.669   -39.897,-31.498 -77.567,-42.289 "
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#fafafa",
  points: "376.3,153.376 371.044,210.351 338.024,219.882 371.044,229.207 376.3,285.566 381.379,229.207   414.228,219.762 381.379,210.351 "
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#fafafa",
  points: "246.277,-80.159 243.204,-46.858 223.906,-41.287 243.204,-35.835 246.277,-2.893 249.247,-35.835   268.447,-41.356 249.247,-46.858 "
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#fafafa",
  strokeWidth: 5,
  points: "270.286,127.636 270.286,94.098 257.783,94.098 250.68,67.555   261.503,61.306 244.72,32.259 233.905,38.5 214.482,19.074 220.727,8.255 191.68,-8.521 185.43,2.308 158.888,-4.823   158.888,-17.307 125.351,-17.307 125.351,-4.811 98.812,2.306 92.563,-8.521 63.524,8.255 69.767,19.067 50.318,38.502 39.5,32.259   22.736,61.295 33.555,67.542 26.447,94.098 13.962,94.098 13.962,127.636 26.445,127.636 33.555,154.176 22.736,160.421   39.5,189.47 50.318,183.225 69.767,202.673 63.524,213.486 92.563,230.248 98.812,219.421 125.351,226.539 125.351,239.033   158.888,239.033 158.888,226.539 185.43,219.418 191.68,230.248 220.727,213.486 214.482,202.667 233.905,183.225 244.72,189.47   261.503,160.421 250.68,154.17 257.783,127.636 "
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#adadad",
  strokeWidth: 1.0562,
  d: "M246.683,112.148c0,57.75-46.811,104.566-104.568,104.566  c-57.749,0-104.547-46.816-104.547-104.566c0-57.753,46.799-104.56,104.547-104.56C199.871,7.588,246.683,54.397,246.683,112.148z"
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  x1: 142.113,
  y1: 7.588,
  x2: 142.113,
  y2: 216.714
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M81.933,27.301c0,0,59.07,27.951,118.101-1.564"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M51.673,60.065c0,0,89.34,42.261,178.623-2.381"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M81.933,197.607c0,0,59.07-27.941,118.101,1.573"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M51.673,164.855c0,0,89.34-42.268,178.623,2.369"
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  x1: 37.554,
  y1: 112.148,
  x2: 246.683,
  y2: 112.148
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M214.012,112.148c0,57.75-32.186,104.566-71.899,104.566  c-39.702,0-71.888-46.816-71.888-104.566c0-57.753,32.186-104.56,71.888-104.56C181.826,7.588,214.012,54.397,214.012,112.148z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#adadad",
  strokeWidth: 2.1123,
  d: "M177.86,112.148c0,57.75-16,104.566-35.748,104.566  c-19.733,0-35.724-46.816-35.724-104.566c0-57.753,15.991-104.56,35.724-104.56C161.86,7.588,177.86,54.397,177.86,112.148z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M293.971-111.137c-71.888-47.806-168.794-33.786-237.946,27.843c0,0,15.022-20.58,28.181-46.196  C48.225-88.969,40.19-82.331,4.11-17.918c-53.926,96.275-32.978,213.374,49.461,268.204c87.654,58.287,212.537,24.647,278.92-75.147  C398.859,75.342,381.613-52.837,293.971-111.137z M57.6,244.244C-21.475,191.642-37.306,76.402,22.261-13.152  c59.568-89.562,171.964-119.527,251.052-66.931c79.074,52.599,94.898,167.852,35.325,257.405  c-8.316,12.505-27.808,33.966-27.808,33.966s29.39-63.5,5.635-124.545c13.274,98.897-21.076,136.821-56.17,159.177  C175.353,280.922,110.443,279.385,57.6,244.244z"
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "110.121,-163.261 93.563,-150.824 82.685,-154.454 84.765,-143.556 72.828,-131.12 88.899,-136.827   93.043,-123.859 99.789,-138.895 115.851,-145.638 103.421,-148.747 "
});

var SvgKorolev = function SvgKorolev(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "770px",
    viewBox: "-157.829 -202.497 600 770",
    enableBackground: "new -157.829 -202.497 600 770",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKorolev, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/korolev.f932b2e6.svg";
export { ForwardRef as ReactComponent };